import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonPage, IonSlide, IonSlides, IonTitle, IonToolbar } from "@ionic/react";
import { logoFacebook, logoInstagram, logoWhatsapp, mailOutline, phonePortraitSharp } from "ionicons/icons";
import React from "react";
import MainTabBar from "../components/MainTabBar";

import "./LocalStore.css";

const slideOpts = {
    initialSlide: 0,
    speed: 400,
};

const slidesGallery = [
    {
        key: 1,
        image: "assets/images/gallery00.jpg",
        description: "",
    },
    {
        key: 2,
        image: "assets/images/gallery01.jpg",
        description: "",
    },
    {
        key: 3,
        image: "assets/images/gallery02.jpg",
        description: "",
    }
];

const sendWhatsappMessage = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = "https://wa.me/393385690164?text=Ciao,%20sono%20interessato%20a%20MenuOnline%20";
    return null;
};

const LocalStore: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton></IonMenuButton>
                    </IonButtons>
                    <IonTitle>Nome Locale</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent forceOverscroll={true}>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Nome Locale</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <div className="ion-padding">
                    <IonSlides pager={true} options={slideOpts} className="slide-container">
                        {slidesGallery.map((element) => {
                            return (
                                <IonSlide key={element.key}>
                                    <img src={element.image} alt={element.description} />
                                </IonSlide>
                            );
                        })}
                    </IonSlides>
                    <h4 style={{ marginBottom: "5px" }}>
                        <strong>Dove siamo:</strong>
                    </h4>
                    <p style={{ marginTop: "0" }}>
                        Via Aldo Moro, 31<br />
                        40035 Castiglione dei Pepoli (BO)
                    </p>
                    <p>
                        <a href="comgooglemaps://?saddr=officina15+castiglione+dei+pepoli&amp;directionsmode=driving" target="_blank" rel="noopener noreferrer">Indicazioni Stradali</a>
                    </p>
                    <h4 style={{ marginBottom: "5px" }}>
                        <strong>Orari di apertura:</strong>
                    </h4>
                    <p style={{ marginTop: "0" }}>
                        Aperto tutti giorni
                        <br />
                        dalle ore 06:00 alle ore 18:00
                    </p>
                    <h4 style={{ marginBottom: "5px" }}>
                        <strong>Contattaci:</strong>
                    </h4>
                    <p style={{ marginTop: "0" }}>
                        <IonIcon icon={phonePortraitSharp} /> <a href="tel:+393385690164">+39 338 569 0164</a>
                        <br />
                        <IonIcon icon={mailOutline} /> <a href="mailto:info@ofcn15.com">info@ofcn15.com</a>
                        <br />
                        <br />
                        <IonButton fill="solid" href="https://www.facebook.com/Ofcn15" target="_blank">
                            <IonIcon icon={logoFacebook} />
                        </IonButton>
                        <IonButton color="danger" fill="solid" href="https://www.instagram.com/ofcn15/" target="_blank">
                            <IonIcon icon={logoInstagram} />
                        </IonButton>
                        <IonButton color="success" fill="solid" onClick={(e) => sendWhatsappMessage(e)}>
                            <IonIcon icon={logoWhatsapp} />
                        </IonButton>
                    </p>
                </div>
            </IonContent>
            <MainTabBar />
        </IonPage>
    );
};

export default LocalStore;
